import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Image from '../../../components/ContentfulImage';
import Slider from '../../../components/Slider/Slider';
import Markdown from '../../../components/Markdown';
import Placeholder from '../../../components/Placeholder';
import { scrollToElementById } from '../../../utils';

import {
  Description,
  DescriptionContainer,
  DescriptionWrapper,
  DescriptionImageWrapper,
  ImageWrapper,
  TitleWrapper,
  TopicDescription,
  TopicTitle,
  TopicWrapper,
  TopicsWrapper,
  SliderWrapper,
  ColumnContainer,
  ColumnWrapper,
  ColumnImageWrapper,
  ColumnTitle,
  ColumnSubTitle,
  Wrapper,
  ButtonWrapper,
  Button,
  OneImageContainer,
} from './RangeEditorial.style';

const generateTopics = topics =>
  topics.map((topic, i) => (
    <TopicWrapper key={topic.title || topic.key} isFirst={i === 0}>
      <ImageWrapper>
        {topic.image ? (
          <Image src={topic.image} options={{ size: 350, objectFit: 'cover', w: '100%' }} />
        ) : (
          <Placeholder w="100%" pb="100%" />
        )}
      </ImageWrapper>
      <TopicTitle>{topic.title || <Placeholder w="50%" h="24px" />}</TopicTitle>
      {topic.description ? (
        <Markdown src={topic.description} Component={TopicDescription} />
      ) : (
        // <TopicDescription>
        //   <Placeholder w="100%" pb="15%" />
        // </TopicDescription>
        null
      )}
    </TopicWrapper>
  ));

const scrollToProdcuts = (anchorLabel, quickLinks) => {
    quickLinks.map(link => {
      if (link.label === anchorLabel) {
        scrollToElementById(link.id);
      }
    });
  };

const RangeEditorial = ({
  locale,
  entryId,
  description,
  title,
  topics,
  image,
  oneImage,
  column,
  link,
  quickLinks,
  // CMS で登録されている子要素
  additionalText,
}) => (
  <Wrapper id={entryId || null}>
    {/* 小見出し (CMS で登録されている Title: 例) HOW TO USE) */}
    <TitleWrapper>{title || <Placeholder w="200px" h="18px" />}</TitleWrapper>
    {/* 商品説明 (CMS で登録されている Description) */}
    <DescriptionContainer>
      <DescriptionWrapper className={image && image !== '' ? '' : 'full-width'}>
        {description ? (
          <Markdown src={description} Component={Description} />
        ) : (
          <Description>
            <Placeholder w="100%" pb="30%" />
          </Description>
        )}
      </DescriptionWrapper>
      
      {image && image !== '' ? (
        <DescriptionImageWrapper>
          {image ? (
            <Image src={image} options={{ size: 530, objectFit: 'cover', w: '100%' }} />
          ) : (
            <Placeholder w="100%" pb="56.6%" />
          )}
        </DescriptionImageWrapper>
      ) : (
        null
      )}
    </DescriptionContainer>

    {additionalText && additionalText.map(child => (
      <DescriptionContainer key={child.name}>
        <DescriptionWrapper>
          {child.description ? (
            <Markdown src={child.description} Component={Description} />
          ) : (
            <Description>
              <Placeholder w="100%" pb="30%" />
            </Description>
          )}
        </DescriptionWrapper>
        <DescriptionImageWrapper>
          {child.image ? (
            <Image src={child.image} options={{ size: 530, objectFit: 'cover', w: '100%' }} />
          ) : (
            <Placeholder w="100%" pb="56.6%" />
          )}
        </DescriptionImageWrapper>
      </DescriptionContainer>
    ))}

    {topics && (
      <React.Fragment>
        <TopicsWrapper>{generateTopics(topics)}</TopicsWrapper>
        <SliderWrapper>
          <Slider options={{ loop: false }} dots={false}>
            {generateTopics(topics)}
          </Slider>
        </SliderWrapper>
      </React.Fragment>
    )}

    {oneImage && (
      <OneImageContainer>
        <Image src={oneImage} options={{ objectFit: 'cover' }} />
      </OneImageContainer>
    )}

    {column && (
      <ColumnContainer>
        <ColumnWrapper className={column.image && column.image !== '' ? '' : 'full-width'}>
          <ColumnTitle>{column.title || <Placeholder w="100%" pb="30%" />}</ColumnTitle>
          <ColumnSubTitle>{column.subtitle || <Placeholder w="100%" pb="30%" />}</ColumnSubTitle>
          {column.description ? (
            <Markdown src={column.description} Component={Description} />
          ) : (
            <Description>
              <Placeholder w="100%" pb="30%" />
            </Description>
          )}
        </ColumnWrapper>
        
        {column.image && column.image !== '' ? (
          <ColumnImageWrapper>
            {column.image ? (
              <Image src={column.image} options={{ size: 530, objectFit: 'cover', w: '100%' }} />
            ) : (
              <Placeholder w="100%" pb="56.6%" />
            )}
          </ColumnImageWrapper>
        ) : (
          null
        )}
      </ColumnContainer>
    )}

    {link && (
      <ButtonWrapper>
        {link.anchorLabel && link.anchorLabel !== '' ? (
          <Button onClick={e => scrollToProdcuts(link.anchorLabel, quickLinks)}>
            {link.label || <Placeholder w="50%" h="20px" />}
          </Button>
        ) : (
          <Link
            className="button"
            to={link.url && link.url !== '' ? `/${locale}${link.url}` : null}
            href={link.url && link.url !== '' ? `/${locale}${link.url}` : null}
            target={link.external ? '_blank' : null}
          >
            {link.label || <Placeholder w="50%" h="20px" />}
          </Link>
        )}
      </ButtonWrapper>
    )}
  </Wrapper>
);

RangeEditorial.defaultProps = {
  locale: undefined,
  entryId: undefined,
  description: undefined,
  image: undefined,
  oneImage: undefined,
  title: undefined,
  topics: undefined,
  column: undefined,
  link: undefined,
  quickLinks: undefined,
};

RangeEditorial.propTypes = {
  locale: PropTypes.string,
  entryId: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.shape(),
  oneImage: PropTypes.shape(),
  title: PropTypes.string,
  topics: PropTypes.arrayOf(PropTypes.shape()),
  column: PropTypes.shape(),
  link: PropTypes.shape(),
  quickLinks: PropTypes.arrayOf(PropTypes.shape()),
};

export default RangeEditorial;



// WEBPACK FOOTER //
// ./src/pages/RangePage/RangeEditorial/RangeEditorial.js